import React from "react";
import "./spinner.css";

export default function Spinner() {
  return (
    <div className={"ispinner"}>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
      <div className={"ispinnerBlade"}></div>
    </div>
  );
}
